/**
 * @author Charles Blais <charles.blais@nrcan-rncan.gc.ca>
 */
import { Alert } from 'react-bootstrap';

import useStationsInfo from '../hooks/use-stations-info';

import { useAppState } from '../contexts/app-state-provider';

import { useLanguageState } from '../contexts/language-state-provider';

import TableStationsInfo from '../components/tables/table-stations-info';

import StationsMap from '../components/maps/stations-map';



const ContainerNetwork = () => {
  const [ state ] = useAppState();
  const [ lang ] = useLanguageState();
  const { stations, loading, error } = useStationsInfo({initialUrl: state.url})

  if (loading) {
    return (
      <Alert bsStyle="info">
        <h2>{ lang.loading.title }</h2>
        <p>{lang.loading.stationsinfo}</p>
      </Alert>
    )
  }

  if (error) {
    return (
      <Alert bsStyle="danger">
        <h2>{ lang.error.title }</h2>
        <p>{lang.error.stationsinfo}</p>
      </Alert>
    )
  }

  return (
    <>
      <details>
        <summary>Instructions</summary>
        <p>{lang.instruction}</p>
      </details>
      <StationsMap stations={stations} />
      <TableStationsInfo stations={stations} />
    </>
  )
}

export default ContainerNetwork;
